type DescriptionTextProps = {
  children: React.ReactNode;
};

export default function DescriptionText({ children }: DescriptionTextProps) {
  return <span className={"descriptionText"}>{children}</span>;
}
